// extracted by css-extract-rspack-plugin
export default {"TableHeader":"DsQvUXVPXMM7Jb4o","slim":"ZqjhBucBTMFaWQQr"};